import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { UnknownErrorPage } from '@maui/pages'
import Root from './Root'

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(error, info, props) {
    console.error('mfe boundary error', { error, info, props })
    return <UnknownErrorPage />
  },
})

export const { bootstrap, mount, unmount } = lifecycles
